module.exports = __webpack_public_path__ + "public/images/tg_icon.e0e0b464174968641721a67efdf069dc.png";